import adventure from 'app/assets/images/infoCollection/purposes/adventure.svg'
import sightseeing from 'app/assets/images/infoCollection/purposes/sightseeing.svg'
import culture from 'app/assets/images/infoCollection/purposes/culture.svg'
import relaxation from 'app/assets/images/infoCollection/purposes/relaxation.svg'
import food from 'app/assets/images/infoCollection/purposes/food.svg'
import photography from 'app/assets/images/infoCollection/purposes/photography.svg'
import wellness from 'app/assets/images/infoCollection/purposes/wellness.svg'
import womenOnly from 'app/assets/images/infoCollection/purposes/women-only.svg'
import other from 'app/assets/images/infoCollection/purposes/other.svg'
import star3 from 'app/assets/images/infoCollection/group/group_size_1.svg?component'
import star4 from 'app/assets/images/infoCollection/group/group_size_2.svg?component'
import star5 from 'app/assets/images/infoCollection/group/group_size_3.svg?component'
import starBoutique from 'app/assets/images/infoCollection/group/group_size_3.svg?component'
import faith from 'app/assets/images/infoCollection/purposes/faith.svg'
import { isFeatureEnabled } from '@/utils/featureUtils.js'

const basePurposesAndVibes = {
  Adventure: {
    icon: adventure,
    vibes: ['Hikes & trails', 'Nature excursions', 'Outdoor sports', 'Water sports'],
  },
  Sightseeing: {
    icon: sightseeing,
    vibes: ['Hidden gems', 'Iconic landmarks', 'Architecture', 'Walking tours'],
  },
  Culture: {
    icon: culture,
    vibes: ['Historic landmarks', 'Arts & museums', 'Music & dance', 'Cultural tradition'],
  },

  'Rest & relaxation': {
    icon: relaxation,
    vibes: ['Beaches', 'Boat cruises', 'Slow days', 'Spa & massages'],
  },
  'Food & flavor': {
    icon: food,
    vibes: ['Street food', 'Fine dining', 'Vegetarian tours', 'Cooking classes'],
  },
  'Photography & creativity': {
    icon: photography,
    vibes: ['Scenic tours', 'Wildlife expeditions', 'Urban living', 'Cultural immersion'],
  },
  'Wellness retreat': {
    icon: wellness,
    vibes: ['Yoga', 'Spa days', 'Detox programmes', 'Host workshops'],
  },
  'Women only': {
    icon: womenOnly,
    vibes: [], // intentionally empty — describes who's travelling, not activities
  },
  'Christian faith': {
    icon: faith,
    vibes: [],
    label: 'Faith-based',
    bodyText:
      "*We currently support travel experiences rooted in Christianity, and we'll be expanding to other traditions as we grow.",
  },
  'Something else': {
    icon: other,
    vibes: null, // free text input
  },
}

export const travelPaceList = [`Slow travel`, `A mix of both`, `Packed schedule`]

export const accommodationOptions = [
  { value: '3-star-hotel', name: '3-star hotel', description: 'Comfortable & convenient', icon: star3 },
  { value: '4-star-hotel', name: '4-star hotel', description: 'Stylish, elevated & comfort', icon: star4 },
  { value: '5-star-hotel', name: '5-star hotel', description: 'Luxury at its finest', icon: star4 },
  { value: 'boutique-hotel', name: ' Boutique hotels', description: 'Unique & full of character', icon: starBoutique },
]

export const accommodationList = accommodationOptions.map(option => option.name)

export const foodExperienceList = [
  `Street food`,
  `Fine dining`,
  `Plant-based options`,
  `Cooking classes`,
  `Food isn't a priority for me`,
]

export const budgetList = {
  'Under USD 1,500': [null, 1500],
  'USD 1,500 - USD 2,000': [1500, 2000],
  'USD 2,000 - USD 2,500': [2000, 2500],
  'USD 2,500+': [2500, null],
  "I don't have a budget in mind": [null, null],
}

const buildPurposesAndVibes = () => {
  const entries = { ...basePurposesAndVibes }
  if (!isFeatureEnabled('religious_trip')) {
    delete entries['Christian faith']
  }
  return entries
}

export const purposesAndVibes = buildPurposesAndVibes()
